module.exports = __webpack_public_path__ + "static/media/blog-hai-banner@2x.6f82daeb.jpg";